export const BASE_URL: string = "/writer/web";